let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jnFv5")).then(() => parcelRequire('oyKRX'));